export const Toast = (() => {
  const containerId = "toast-container";

  function ensureContainer() {
    let container = document.getElementById(containerId);
    if (!container) {
      container = document.createElement("div");
      container.id = containerId;
      container.style.position = "fixed";
      container.style.bottom = "20px";
      container.style.left = "20px";
      container.style.display = "flex";
      container.style.flexDirection = "column";
      container.style.gap = "10px";
      container.style.zIndex = "9999";
      document.body.appendChild(container);
    }
    return container;
  }

  function createToast(id: string, message: string) {
    const container = ensureContainer();

    const toast = document.createElement("div");
    toast.className = "toast";
    toast.dataset.id = id;
    toast.style.minWidth = "250px";
    toast.style.padding = "12px";
    toast.style.borderRadius = "8px";
    toast.style.background = "#222";
    toast.style.color = "#fff";
    toast.style.fontFamily = "sans-serif";
    toast.style.boxShadow = "0 4px 10px rgba(0,0,0,0.2)";

    const text = document.createElement("div");
    text.className = "toast-message";
    text.innerText = message;
    text.style.marginBottom = "8px";

    const progressWrapper = document.createElement("div");
    progressWrapper.style.height = "6px";
    progressWrapper.style.background = "rgba(255,255,255,0.2)";
    progressWrapper.style.borderRadius = "4px";
    progressWrapper.style.overflow = "hidden";

    const progressBar = document.createElement("div");
    progressBar.className = "toast-progress";
    progressBar.style.height = "100%";
    progressBar.style.width = "0%";
    progressBar.style.background = "#2959A6";
    progressBar.style.transition = "width 0.2s ease";

    progressWrapper.appendChild(progressBar);
    toast.appendChild(text);
    toast.appendChild(progressWrapper);
    container.appendChild(toast);

    return toast;
  }

  function getToast(id: string) {
    return document.querySelector(`.toast[data-id="${id}"]`);
  }

  return {
    show(id: string, message = "Загрузка...") {
      if (!getToast(id)) {
        createToast(id, message);
      }
    },

    update(id: string, percent: number) {
      const toast = getToast(id);
      if (!toast) return;

      const bar = toast.querySelector(".toast-progress") as HTMLElement;
      if (bar) {
        // 
        bar.style.width = `${Math.max(0, Math.min(100, percent))}%`;
      }
    },

    success(id: string, message = "Готово") {
      const toast = getToast(id);
      if (!toast) return;

      const text = toast.querySelector(".toast-message") as HTMLTitleElement;
      const bar = toast.querySelector(".toast-progress") as HTMLElement;

      // 
      if (text) text.innerText = message;
      // 
      if (bar) bar.style.background = "#2959A6";

      setTimeout(() => this.hide(id), 1500);
    },

    error(id: string, message = "Ошибка") {
      const toast = getToast(id);
      if (!toast) return;

      const text = toast.querySelector(".toast-message") as HTMLTextAreaElement;
      const bar = toast.querySelector(".toast-progress") as HTMLElement;

      // 
      if (text) text.innerText = message;
      // 
      if (bar) bar.style.background = "#f44336";

      setTimeout(() => this.hide(id), 2000);
    },

    hide(id: string) {
      const toast = getToast(id);
      if (toast) {
        toast.remove();
      }
    }
  };
})();

// Пример использования:
// Toast.show("upload");
// Toast.update("upload", 30);
// Toast.success("upload");
// Toast.error("upload");






export const MessageToast = (() => {
  const containerId = "toast-container";

  function ensureContainer() {
    let container = document.getElementById(containerId);
    if (!container) {
      container = document.createElement("div");
      container.id = containerId;
      container.style.position = "fixed";
      container.style.bottom = "20px";
      container.style.left = "20px";
      container.style.display = "flex";
      container.style.flexDirection = "column";
      container.style.gap = "10px";
      container.style.zIndex = "9999";
      document.body.appendChild(container);
    }
    return container;
  }

  function createToast(id: string, message: string, type: string) {
    const container = ensureContainer();
    let bg = "#222";

    if(type == 'danger'){
      bg = "#b92525";
    }
    if(type == 'info'){
      bg = "#3c98ee";
    }
    if(type == 'success'){
      bg = "#28a745";
    }

    const toast = document.createElement("div");
    toast.className = "toast";
    toast.dataset.id = id;
    toast.style.minWidth = "250px";
    toast.style.padding = "12px";
    toast.style.borderRadius = "8px";
    toast.style.background = bg;
    toast.style.color = "#fff";
    toast.style.fontFamily = "sans-serif";
    toast.style.boxShadow = "0 4px 10px rgba(0,0,0,0.2)";
    toast.style.textAlign = "center";
    toast.style.transition = "3s ease";

    const text = document.createElement("div");
    text.className = "toast-message";
    text.innerText = message;
    
    
    toast.appendChild(text);
    container.appendChild(toast);

    setTimeout(() => {
      container.removeChild(toast);
    }, 2000)

    return toast;
  }

  function getToast(id: string) {
    return document.querySelector(`.toast[data-id="${id}"]`);
  }

  return {
    show(id: string, message?: string) {
      // Поддержка вызова с одним аргументом: showDanger("текст") — раньше в
      // этом случае текст уходил в id, а показывалось "Загрузка...".
      if (message === undefined) { message = id; id = "msg:" + message; }
      if (!getToast(id)) {
        createToast(id, message ?? "Загрузка...", 'info');
      }
    },

    showDanger(id: string, message?: string) {
      if (message === undefined) { message = id; id = "danger:" + message; }
      if (!getToast(id)) {
        createToast(id, message ?? "Ошибка", 'danger');
      }
    },

    update(id: string, percent: string) {
      const toast = getToast(id);
      if (!toast) return;

      const bar = toast.querySelector(".toast-progress") as HTMLElement;
      if (bar) {
        bar.style.width = `${Math.max(0, Math.min(100, parseFloat(percent)))}%`;
      }
    },

    success(id: string, message = "Готово") {
      
      const toast = createToast(id, message, 'success');

      const text = toast.querySelector(".toast-message") as HTMLTitleElement;
      const bar = toast.querySelector(".toast-progress") as HTMLElement;

      if (text) text.innerText = message;
      if (bar) bar.style.background = "#2959A6";

      setTimeout(() => this.hide(id), 1500);
    },

    error(id: string, message = "Ошибка") {
      const toast = getToast(id);
      if (!toast) return;

      const text = toast.querySelector(".toast-message") as HTMLTitleElement;
      const bar = toast.querySelector(".toast-progress") as HTMLElement;

      if (text) text.innerText = message;
      if (bar) bar.style.background = "#f44336";

      setTimeout(() => this.hide(id), 2000);
    },

    hide(id: string) {
      const toast = getToast(id);
      if (toast) {
        toast.remove();
      }
    }
  };
})();

// Пример использования:
// Toast.show("upload");
// Toast.update("upload", 30);
// Toast.success("upload");
// Toast.error("upload");